export const ageGroups = [
   {name: 'Kids 6-12', value: "kids"},
   {name: 'Teenagers 13-17', value: "teenagers"},
   {name: 'Adults', value: "adults"}
]